import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './buyOnlineContent.module.css';
import { useOnlineDealers } from '../../../../../pages/Dealers/useInternationalDealers';
import OnlineDealerItem from '../../../../../pages/Dealers/onlineDealerItem';

var BuyOnlineContent = function BuyOnlineContent(props) {
  var _data$onlinedealers;

  var classes = useStyle(defaultClasses, props.classes);

  var _useOnlineDealers = useOnlineDealers(),
      loading = _useOnlineDealers.loading,
      error = _useOnlineDealers.error,
      data = _useOnlineDealers.data;

  var productUrls = props === null || props === void 0 ? void 0 : props.customAttributes.filter(function (attr) {
    var _attr$attribute_metad;

    return attr === null || attr === void 0 ? void 0 : (_attr$attribute_metad = attr.attribute_metadata) === null || _attr$attribute_metad === void 0 ? void 0 : _attr$attribute_metad.code.includes('hf_product_url');
  }).map(function (item) {
    var _item$entered_attribu;

    return item === null || item === void 0 ? void 0 : (_item$entered_attribu = item.entered_attribute_value) === null || _item$entered_attribu === void 0 ? void 0 : _item$entered_attribu.value;
  });
  var onlineGroup = data === null || data === void 0 ? void 0 : (_data$onlinedealers = data.onlinedealers) === null || _data$onlinedealers === void 0 ? void 0 : _data$onlinedealers.filter(function (item) {
    return productUrls.find(function (pUrl) {
      return pUrl.includes(item.url);
    });
  }).map(function (item, index) {
    return React.createElement(OnlineDealerItem, {
      key: index,
      item: item,
      isPdpPage: true
    });
  }).sort(function (a, b) {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    if (a.name === b.name) return 0;
  });
  var onlineGroupData = productUrls === null || productUrls === void 0 ? void 0 : productUrls.map(function (productUrl, index) {
    var _data$onlinedealers2;

    var dealer = data === null || data === void 0 ? void 0 : (_data$onlinedealers2 = data.onlinedealers) === null || _data$onlinedealers2 === void 0 ? void 0 : _data$onlinedealers2.find(function (dealer) {
      var dUrl = dealer !== null && dealer !== void 0 && dealer.url ? new URL(dealer === null || dealer === void 0 ? void 0 : dealer.url) : null;
      return productUrl.includes(dUrl === null || dUrl === void 0 ? void 0 : dUrl.host);
    });

    var item = _objectSpread(_objectSpread({}, dealer), {}, {
      url: productUrl
    });

    return React.createElement(OnlineDealerItem, {
      key: index,
      item: item,
      isPdpPage: true
    });
  }).sort(function (a, b) {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    if (a.name === b.name) return 0;
  });
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: classes.titleDealers
  }, "See Our Online Dealers Below"), React.createElement("div", {
    className: classes.wrapper
  }, React.createElement("div", {
    className: classes.dealersWrapper
  }, onlineGroupData)));
};

export default BuyOnlineContent;